import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    customClass: {

    },
    container: {
      display: 'block',
      margin: '0 auto',
      width: 400,
      textAlign: 'center',
      '& label': {
        color: theme.custom.colors.primary,
      },
      '& .style-button-remove': {
        zIndex: 9,
        right: 0,
      }
    },
    customInput: {
      width: 401,
      marginBottom: 41,
    },
    uploadImageTxt: {
      font: theme.custom.font.paragraph3,
    },
    selectAppIcon: {
      display: "flex",
      justifyContent: "center",
    },
    uploadTxtHeader: {
      marginBottom: 10,
      font: theme.custom.font.montserrat14Bold,
    },
    uploadContainer: {
      display: "flex", 
      flexDirection: "column", 
      justifyContent: "center",
      paddingLeft: "10px",
      paddingRight: "10px"
    }, //
    uploadText: {
      font: theme.custom.font.paragraph2,
    }
  };
});

export default useStyles;
